import JoinDyteLinkMeeting from "./JoinDyteLinkMeeting"

export default JoinDyteLinkMeeting
